/*
 * @Author: Tahiti
 * @Date: 2025-01-27 12:00:00
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-18 16:26:22
 * @Description: 页脚组件多语言配置
 * @FilePath: /weryai-web/locales/modules/footer.ts
 */
export default {
    zh: {
        tagline: '您的一站式AI 视频和图像创作平台',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: '视频工具',
        aiEffects: 'AI 特效',
        imageTools: '图像工具',
        videoModels: '视频模型',
        imageModels: '图像模型',
        company: '公司',
        aboutUsLink: '关于我们',
        contactUs: '联系我们',
        pricingLink: '定价',
        faqs: '常见问题',
        refundPolicy: '退款政策',
        privacyPolicy: '隐私政策',
        termsAndConditions: '服务条款',
        // 视频工具
        imageToVideoAI: '图生视频 AI',
        textToVideoAI: '文生视频 AI',
        aiVideoEditor: 'AI 视频编辑器',
        aiWatermarkRemoval: 'AI 去水印',
        aiVideoFaceSwap: 'AI 视频换脸',
        aiVideoLipSync: 'AI 对口型',
        aiVideoSubtitleErase: 'AI 字幕擦除',
        aiVideoStylization: 'AI 视频风格化',
        aiVideoEnhancement: 'AI 视频增强',
        // 图像工具
        aiImageGenerator: 'AI 图像生成器',
        imageToImageAI: '图生图 AI',
        aiImageAspectRatioConverter: 'AI 图像尺寸调整器',
        aiImageUpscaler: 'AI 图像增强',
        aiImageUpscalerDesc: '一键放大、去噪、复原模糊图像',
        aiImageTranslation: 'AI 图片翻译',
        aiImageRatioConversion: 'AI 图片比例转换',
        aiImageQualityUpgrade: 'AI 图片画质升级',
        aiBackgroundChanger: '图片背景更换器',
        aiBackgroundChangerDesc: '用你想要的任何场景替换照片的背景',
        aiDancingVideoGenerator: 'AI 舞蹈视频生成器',
        aiKissingVideoGenerator: 'AI 亲吻视频生成器',
        // 视频模型
        veo31Link: 'Veo 3.1',
        veo31Desc: '提升视频真实感和音频同步',
        veo3: 'Veo 3',
        veo3Desc: '高质量视频生成模型',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: '快速视频生成模型',
        sora2: 'Sora 2',
        sora2Desc: '真实世界和音频模拟',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'WeryAI旗舰模型，极速、电影级、一致性视频叙事',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI 视频创作平台',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: '音画同步视频生成模型',
        KlingO1: 'Kling O1',
        KlingO1Desc: '统一多模态视频模型',
        runway: 'Runway',
        runwayDesc: '专业AI视频编辑平台',
        runway45: 'Runway Gen-4.5',
        runway45Desc: '前所未有的物理模拟，A2D混合架构，电影级的时间连贯性',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: '高级AI视频生成',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: '下一代AI视频创作',
        seedance: 'Seedance',
        seedanceDesc: '创意视频生成 AI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: '高速低成本视频生成',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc: '精确摄像机控制和首尾帧引导的电影级视频生成',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI 视频生成模型',
        pika22: 'Pika 2.2',
        pika22Desc: '清晰、锐利、高清晰度的视觉效果',
        // 图像模型
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: '全球首个“推理图像引擎”',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: '紧凑型高效图像生成',
        flux: 'FLUX',
        fluxDesc: '高质量图像生成模型',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: '上下文感知的图像生成',
        imagen: 'Imagen',
        imagenDesc: 'Google 的先进图像生成',
        gpt4o: 'GPT-4o',
        gpt4oDesc: '多模态AI与图像能力',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen 驱动的图像生成',
        seedream: 'Seedream 4.0',
        seedreamDesc: '创意图像生成平台',
        dreamina: 'Dreamina',
        dreaminaDesc: '电影级 AI 图像生成',
        supportedVideoModels: '支持的视频模型',
        supportedImageModels: '支持的图像模型',
        wanAIImageDesc: 'Wan AI 图像生成模型',
        seedream45: 'Seedream 4.5',
        seedream45Desc: '字节跳动旗舰AI图像模型，精准文字渲染与多图融合',
            nanoBananaProLink: 'Nano Banana Pro',
    },
    en: {
        tagline: 'Your one-stop AI video and image creation platform',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Video Tools',
        aiEffects: 'AI Effects',
        imageTools: 'Image Tools',
        videoModels: 'Video Models',
        imageModels: 'Image Models',
        company: 'Company',
        aboutUsLink: 'About Us',
        contactUs: 'Contact Us',
        pricingLink: 'Pricing',
        faqs: 'FAQs',
        refundPolicy: 'Refund Policy',
        privacyPolicy: 'Privacy Policy',
        termsAndConditions: 'Terms and Conditions',
        // Video Tools
        imageToVideoAI: 'Image to Video AI',
        textToVideoAI: 'Text to Video AI',
        aiVideoEditor: 'AI Video Editor',
        aiWatermarkRemoval: 'AI Watermark Removal',
        aiVideoFaceSwap: 'AI Video Face Swap',
        aiVideoLipSync: 'AI Video Lip Sync',
        aiVideoSubtitleErase: 'AI Subtitle Erase',
        aiVideoStylization: 'AI Video Stylization',
        aiVideoEnhancement: 'AI Video Enhancement',
        // Image Tools
        aiImageGenerator: 'AI Image Generator',
        imageToImageAI: 'Image to Image AI',
        aiImageAspectRatioConverter: 'AI Image Resizer',
        aiImageUpscaler: 'AI Image Upscaler',
        aiImageUpscalerDesc:
            'Upscale, denoise, and restore blurry photos in one click',
        aiImageTranslation: 'AI Image Translation',
        aiImageRatioConversion: 'AI Image Ratio Conversion',
        aiImageQualityUpgrade: 'AI Image Quality Upgrade',
        aiBackgroundChanger: 'AI Background Changer',
        aiBackgroundChangerDesc:
            'Replace photo backgrounds with any scene you want',
        aiDancingVideoGenerator: 'AI Dancing Video Generator',
        aiKissingVideoGenerator: 'AI Kissing Video Generator',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Enhanced realism and audio synchronization',
        veo3: 'Veo 3',
        veo3Desc: 'High-quality video generation model',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Fast video generation model',
        sora2: 'Sora 2',
        sora2Desc: 'Realistic world and audio simulation',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: "微鲤AI\'s flagship model for fast, cinematic, and consistent video storytelling",
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI video creation platform',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Audio-visual synchronized video generation',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Unified multimodal video model',
        runway: 'Runway',
        runwayDesc: 'Professional AI video editing platform',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'Unprecedented physics simulation, A2D hybrid architecture, cinematic temporal coherence',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Advanced AI video generation',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Next-gen AI video creation',
        seedance: 'Seedance',
        seedanceDesc: 'Creative video generation AI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'High-speed low-cost video generation',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'Cinematic video generation with precise camera control and start/end frame guidance',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI video generation model',
        pika22: 'Pika 2.2',
        pika22Desc: 'Crisp, sharp, high-clarity visuals',
        // Image Models
        nanoBananaProLink: 'Nano Banana Pro',
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: `The world's first inference image engine`,
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Compact and efficient image generation',
        flux: 'FLUX',
        fluxDesc: 'High-quality image generation model',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Context-aware image generation',
        imagen: 'Imagen',
        imagenDesc: "Google\'s advanced image generation",
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'Multimodal AI with image capabilities',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen-powered image generation',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Creative image generation platform',
        dreamina: 'Dreamina',
        dreaminaDesc: 'Cinematic AI image generation',
        supportedVideoModels: 'Supported Video Models',
        supportedImageModels: 'Supported Image Models',
        wanAIImageDesc: 'Wan AI image generation model',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            "ByteDance\'s flagship AI image model with precise typography and multi-image fusion",
    },
    ja: {
        tagline: 'あなたのワンストップ AI 動画・画像作成プラットフォーム',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: '動画ツール',
        aiEffects: 'AIエフェクト',
        imageTools: '画像ツール',
        videoModels: '動画モデル',
        imageModels: '画像モデル',
        company: '会社',
        aboutUsLink: '私たちについて',
        contactUs: 'お問い合わせ',
        pricingLink: '料金',
        faqs: 'よくある質問',
        refundPolicy: '返金ポリシー',
        privacyPolicy: 'プライバシーポリシー',
        termsAndConditions: '利用規約',
        // Video Tools
        imageToVideoAI: '画像から動画 AI',
        textToVideoAI: 'テキストから動画 AI',
        aiVideoEditor: 'AI 動画エディター',
        aiWatermarkRemoval: 'AI 透かし除去',
        aiVideoFaceSwap: 'AI 動画顔交換',
        aiVideoLipSync: 'AI 動画リップシンク',
        aiVideoSubtitleErase: 'AI 字幕除去',
        aiVideoStylization: 'AI 動画スタイライゼーション',
        aiVideoEnhancement: 'AI 動画強化',
        // Image Tools
        aiImageGenerator: 'AI 画像ジェネレーター',
        imageToImageAI: '画像から画像 AI',
        aiImageAspectRatioConverter: 'AI 画像サイズ調整ツール',
        aiImageUpscaler: 'AI 画像強化',
        aiImageUpscalerDesc: '画質をアップグレードし、鮮明度を向上',
        aiImageTranslation: 'AI 画像翻訳',
        aiImageRatioConversion: 'AI 画像比率変換',
        aiImageQualityUpgrade: 'AI 画像品質向上',
        aiBackgroundChanger: 'AI 背景変更ツール',
        aiBackgroundChangerDesc: 'お好みのシーンで写真の背景を置き換えます',
        aiDancingVideoGenerator: 'AIダンス動画ジェネレーター',
        aiKissingVideoGenerator: 'AIキス動画ジェネレーター',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: '映像のリアリティと音声同期を強化',
        veo3: 'Veo 3',
        veo3Desc: '高品質な動画生成モデル',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: '高速な動画生成モデル',
        sora2: 'Sora 2',
        sora2Desc: '現実世界と音声を高精度にシミュレーション',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: '高速・シネマティック・一貫性のある動画ストーリーテリングのためのWeryAI旗艦モデル',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI 動画クリエイションプラットフォーム',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: '音画同期動画生成モデル',
        KlingO1: 'Kling O1',
        KlingO1Desc: '統一マルチモーダル動画モデル',
        runway: 'Runway',
        runwayDesc: 'プロ向け AI 動画編集プラットフォーム',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            '前例のない物理シミュレーション、A2Dハイブリッドアーキテクチャ、映画のような時間的一貫性',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: '高度な AI 動画生成',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: '次世代の AI 動画クリエイション',
        seedance: 'Seedance',
        seedanceDesc: 'クリエイティブ動画生成 AI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: '高速・低コストの動画生成',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            '精密なカメラ制御と開始/終了フレームガイダンスによるシネマティック動画生成',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI 動画生成モデル',
        pika22: 'Pika 2.2',
        pika22Desc: 'クリアでシャープな高画質映像',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: '世界初の「推論画像エンジン」',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'コンパクトで高効率な画像生成',
        flux: 'FLUX',
        fluxDesc: '高品質な画像生成モデル',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'コンテキストを理解する画像生成',
        imagen: 'Imagen',
        imagenDesc: 'Google の高度な画像生成モデル',
        gpt4o: 'GPT-4o',
        gpt4oDesc: '画像生成にも対応したマルチモーダル AI',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen ベースの画像生成モデル',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'クリエイティブな画像生成プラットフォーム',
        dreamina: 'Dreamina',
        supportedVideoModels: 'サポートされている動画モデル',
        supportedImageModels: 'サポートされている画像モデル',
        wanAIImageDesc: 'Wan AI 画像生成モデル',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'ByteDanceのフラッグシップAI画像モデル、精密な文字レンダリングとマルチ画像融合',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: '映画のようなAI画像生成',
    },
    ko: {
        tagline: '원스톱 AI 비디오 및 이미지 생성 플랫폼',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: '비디오 도구',
        aiEffects: 'AI 효과',
        imageTools: '이미지 도구',
        videoModels: '비디오 모델',
        imageModels: '이미지 모델',
        company: '회사',
        aboutUsLink: '회사 소개',
        contactUs: '문의하기',
        pricingLink: '가격',
        faqs: '자주 묻는 질문',
        refundPolicy: '환불 정책',
        privacyPolicy: '개인정보 보호정책',
        termsAndConditions: '이용약관',
        // Video Tools
        imageToVideoAI: '이미지에서 비디오 AI',
        textToVideoAI: '텍스트에서 비디오 AI',
        aiVideoEditor: 'AI 비디오 에디터',
        aiWatermarkRemoval: 'AI 워터마크 제거',
        aiVideoFaceSwap: 'AI 비디오 얼굴 교체',
        aiVideoLipSync: 'AI 비디오 립싱크',
        aiVideoSubtitleErase: 'AI 자막 제거',
        aiVideoStylization: 'AI 비디오 스타일화',
        aiVideoEnhancement: 'AI 비디오 향상',
        // Image Tools
        aiImageGenerator: 'AI 이미지 생성기',
        imageToImageAI: '이미지에서 이미지 AI',
        aiImageAspectRatioConverter: 'AI 이미지 크기 조정기',
        aiImageUpscaler: 'AI 이미지 향상',
        aiImageUpscalerDesc: '이미지 품질 업그레이드 및 선명도 향상',
        aiImageTranslation: 'AI 이미지 번역',
        aiImageRatioConversion: 'AI 이미지 비율 변환',
        aiImageQualityUpgrade: 'AI 이미지 품질 향상',
        aiBackgroundChanger: 'AI 배경 변경기',
        aiBackgroundChangerDesc: '원하는 장면으로 사진 배경을 교체하세요',
        aiDancingVideoGenerator: 'AI 댄싱 영상 생성기',
        aiKissingVideoGenerator: 'AI 키스 영상 생성기',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: '영상 현실감과 오디오 동기화 향상',
        veo3: 'Veo 3',
        veo3Desc: '고품질 비디오 생성 모델',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: '고속 비디오 생성 모델',
        sora2: 'Sora 2',
        sora2Desc: '현실 세계와 오디오 시뮬레이션',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: '빠르고 시네마틱하며 일관된 비디오 스토리텔링을 위한 微鲤AI 플래그십 모델',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI 비디오 크리에이션 플랫폼',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: '음화 동기화 비디오 생성 모델',
        KlingO1: 'Kling O1',
        KlingO1Desc: '통합 멀티모달 비디오 모델',
        runway: 'Runway',
        runwayDesc: '프로용 AI 비디오 편집 플랫폼',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            '전례 없는 물리 시뮬레이션, A2D 하이브리드 아키텍처, 영화 같은 시간적 일관성',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: '고급 AI 비디오 생성',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: '차세대 AI 비디오 크리에이션',
        seedance: 'Seedance',
        seedanceDesc: '크리에이티브 비디오 생성 AI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: '고속·저비용 비디오 생성',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            '정밀한 카메라 제어와 시작/끝 프레임 가이던스로 시네마틱 비디오 생성',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI 비디오 생성 모델',
        pika22: 'Pika 2.2',
        pika22Desc: '선명하고 또렷한 고화질 영상',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: '세계 최초의 "추론 이미지 엔진"',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: '컴팩트하고 효율적인 이미지 생성',
        flux: 'FLUX',
        fluxDesc: '고품질 이미지 생성 모델',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: '문맥 인식 이미지 생성',
        imagen: 'Imagen',
        imagenDesc: 'Google의 고급 이미지 생성 모델',
        gpt4o: 'GPT-4o',
        gpt4oDesc: '이미지 기능을 갖춘 멀티모달 AI',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen 기반 이미지 생성',
        seedream: 'Seedream 4.0',
        seedreamDesc: '크리에이티브 이미지 생성 플랫폼',
        dreamina: 'Dreamina',
        supportedVideoModels: '지원되는 비디오 모델',
        supportedImageModels: '지원되는 이미지 모델',
        wanAIImageDesc: 'Wan AI 이미지 생성 모델',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'ByteDance의 플래그십 AI 이미지 모델, 정밀한 텍스트 렌더링 및 다중 이미지 융합',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: '영화 같은 AI 이미지 생성',
    },
    tw: {
        tagline: '您的一站式 AI 影片與圖像創作平台',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: '影片工具',
        aiEffects: 'AI 特效',
        imageTools: '圖片工具',
        videoModels: '影片模型',
        imageModels: '圖片模型',
        company: '公司',
        aboutUsLink: '關於我們',
        contactUs: '聯絡我們',
        pricingLink: '定價',
        faqs: '常見問題',
        refundPolicy: '退款政策',
        privacyPolicy: '隱私政策',
        termsAndConditions: '服務條款',
        // 影片工具
        imageToVideoAI: '圖生影片 AI',
        textToVideoAI: '文生影片 AI',
        aiVideoEditor: 'AI 影片編輯器',
        aiWatermarkRemoval: 'AI 去浮水印',
        aiVideoFaceSwap: 'AI 影片換臉',
        aiVideoLipSync: 'AI 影片對口型',
        aiVideoSubtitleErase: 'AI 字幕擦除',
        aiVideoStylization: 'AI 影片風格化',
        aiVideoEnhancement: 'AI 影片增強',
        // 圖像工具
        aiImageGenerator: 'AI 圖像生成器',
        imageToImageAI: '圖生圖 AI',
        aiImageAspectRatioConverter: 'AI 圖像尺寸調整器',
        aiImageUpscaler: 'AI 圖像增強',
        aiImageUpscalerDesc: '一鍵放大、降噪並修復模糊影像',
        aiImageTranslation: 'AI 圖片翻譯',
        aiImageRatioConversion: 'AI 圖片比例轉換',
        aiImageQualityUpgrade: 'AI 圖片畫質升級',
        aiBackgroundChanger: '圖片背景更換器',
        aiBackgroundChangerDesc: '用你想要的任何場景替換照片背景',
        aiDancingVideoGenerator: 'AI 舞蹈影片生成器',
        aiKissingVideoGenerator: 'AI 親吻影片生成器',
        // 影片模型
        veo31Link: 'Veo 3.1',
        veo31Desc: '提升影片真實感與音訊同步',
        veo3: 'Veo 3',
        veo3Desc: '高品質影片生成模型',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: '快速影片生成模型',
        sora2: 'Sora 2',
        sora2Desc: '真實世界與音訊模擬',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: '微鲤AI 旗艦模型，快速、電影級且敘事一致',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI 影片創作平台',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: '音畫同步影片生成模型',
        KlingO1: 'Kling O1',
        KlingO1Desc: '統一多模態影片模型',
        runway: 'Runway',
        runwayDesc: '專業 AI 影片編輯平台',
        runway45: 'Runway Gen-4.5',
        runway45Desc: '前所未有的物理模擬、A2D 混合架構、電影級時間連貫性',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: '進階 AI 影片生成',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: '下一代 AI 影片創作',
        seedance: 'Seedance',
        seedanceDesc: '創意影片生成 AI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: '高速、低成本影片生成',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc: '精準攝影機控制與首尾幀引導的電影級影片生成',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI 影片生成模型',
        pika22: 'Pika 2.2',
        pika22Desc: '清晰、銳利、高解析度的視覺效果',
        // 圖像模型
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: '全球首個「推理圖像引擎」',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: '緊湊且高效的圖像生成',
        flux: 'FLUX',
        fluxDesc: '高品質圖像生成模型',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: '上下文感知的圖像生成',
        imagen: 'Imagen',
        imagenDesc: 'Google 的先進圖像生成',
        gpt4o: 'GPT-4o',
        gpt4oDesc: '具備圖像能力的多模態 AI',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen 驅動的圖像生成',
        seedream: 'Seedream 4.0',
        seedreamDesc: '創意圖像生成平台',
        dreamina: 'Dreamina',
        supportedVideoModels: '支援的影片模型',
        supportedImageModels: '支援的圖像模型',
        wanAIImageDesc: 'Wan AI 圖像生成模型',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'ByteDance 旗艦 AI 圖像模型，精準文字渲染與多圖融合',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: '電影級 AI 圖像生成',
    },
    pl: {
        tagline: 'Twoja kompleksowa platforma do tworzenia wideo i obrazów AI',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Narzędzia wideo',
        aiEffects: 'Efekty AI',
        imageTools: 'Narzędzia obrazów',
        videoModels: 'Modele wideo',
        imageModels: 'Modele obrazów',
        company: 'Firma',
        aboutUsLink: 'O nas',
        contactUs: 'Kontakt',
        pricingLink: 'Cennik',
        faqs: 'FAQ',
        refundPolicy: 'Polityka zwrotów',
        privacyPolicy: 'Polityka prywatności',
        termsAndConditions: 'Warunki korzystania',
        // Narzędzia wideo
        imageToVideoAI: 'AI obraz→wideo',
        textToVideoAI: 'AI tekst→wideo',
        aiVideoEditor: 'Edytor wideo AI',
        aiWatermarkRemoval: 'Usuwanie znaków wodnych AI',
        aiVideoFaceSwap: 'Zamiana twarzy w wideo AI',
        aiVideoLipSync: 'Synchronizacja ust AI',
        aiVideoSubtitleErase: 'Usuwanie napisów AI',
        aiVideoStylization: 'Stylizacja wideo AI',
        aiVideoEnhancement: 'Poprawa jakości wideo AI',
        // Narzędzia obrazów
        aiImageGenerator: 'Generator obrazów AI',
        imageToImageAI: 'AI obraz→obraz',
        aiImageAspectRatioConverter: 'Zmiana rozmiaru obrazu AI',
        aiImageUpscaler: 'Upscaler obrazów AI',
        aiImageUpscalerDesc:
            'Powiększanie, odszumianie i przywracanie ostrości jednym kliknięciem',
        aiImageTranslation: 'Tłumaczenie obrazów AI',
        aiImageRatioConversion: 'Zmiana proporcji obrazu AI',
        aiImageQualityUpgrade: 'Poprawa jakości obrazu AI',
        aiBackgroundChanger: 'Zmiana tła AI',
        aiBackgroundChangerDesc: 'Zastąp tło dowolną sceną',
        aiDancingVideoGenerator: 'Generator tańczących wideo AI',
        aiKissingVideoGenerator: 'Generator wideo z pocałunkiem AI',
        // Modele wideo
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Lepszy realizm wideo i synchronizacja dźwięku',
        veo3: 'Veo 3',
        veo3Desc: 'Model generowania wideo wysokiej jakości',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Szybki model generowania wideo',
        sora2: 'Sora 2',
        sora2Desc: 'Realistyczna symulacja świata i dźwięku',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc:
            'Flagowy model 微鲤AI: szybkie, kinowe i spójne opowiadanie wideo',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'Platforma tworzenia wideo AI',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Model generowania wideo z synchronizacją audio-wideo',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Zunifikowany multimodalny model wideo',
        runway: 'Runway',
        runwayDesc: 'Profesjonalna platforma edycji wideo AI',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'Bezprecedensowa symulacja fizyki, hybrydowa architektura A2D, kinowa spójność czasowa',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Zaawansowane generowanie wideo AI',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Nowa generacja tworzenia wideo AI',
        seedance: 'Seedance',
        seedanceDesc: 'Kreatywne generowanie wideo AI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Szybkie i tanie generowanie wideo',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'Kinowe generowanie wideo z precyzyjną kontrolą kamery i prowadzeniem klatek start/koniec',
        wanAI: 'Wan AI',
        wanAIDesc: 'Model generowania wideo Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'Wyraźne, ostre i bardzo czytelne wizualizacje',
        // Modele obrazów
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: 'Pierwszy na świecie „silnik wnioskowania obrazów”',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Kompaktowe i wydajne generowanie obrazów',
        flux: 'FLUX',
        fluxDesc: 'Model generowania obrazów wysokiej jakości',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Generowanie obrazów z uwzględnieniem kontekstu',
        imagen: 'Imagen',
        imagenDesc: 'Zaawansowane generowanie obrazów od Google',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'Multimodalna AI z możliwościami obrazów',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Generowanie obrazów oparte na Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Platforma kreatywnego generowania obrazów',
        dreamina: 'Dreamina',
        supportedVideoModels: 'Obsługiwane modele wideo',
        supportedImageModels: 'Obsługiwane modele obrazów',
        wanAIImageDesc: 'Model generowania obrazów Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'Flagowy model obrazów AI ByteDance z precyzyjnym renderowaniem tekstu i łączeniem wielu obrazów',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: 'Kinowe generowanie obrazów AI',
    },
    es: {
        tagline:
            'Tu plataforma integral de creación de videos e imágenes con IA',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Herramientas de Video',
        aiEffects: 'AI Efectos',
        imageTools: 'Herramientas de Imagen',
        videoModels: 'Modelos de Video',
        imageModels: 'Modelos de Imagen',
        company: 'Empresa',
        aboutUsLink: 'Acerca de Nosotros',
        contactUs: 'Contáctanos',
        pricingLink: 'Precios',
        faqs: 'Preguntas Frecuentes',
        refundPolicy: 'Política de Reembolso',
        privacyPolicy: 'Política de Privacidad',
        termsAndConditions: 'Términos y Condiciones',
        // Video Tools
        imageToVideoAI: 'Imagen a Video IA',
        textToVideoAI: 'Texto a Video IA',
        aiVideoEditor: 'Editor de Video IA',
        aiWatermarkRemoval: 'Eliminación de Marca de Agua IA',
        aiVideoFaceSwap: 'Intercambio de Cara en Video IA',
        aiVideoLipSync: 'Sincronización de Labios en Video IA',
        aiVideoSubtitleErase: 'Eliminación de Subtítulos IA',
        aiVideoStylization: 'Estilización de Video IA',
        aiVideoEnhancement: 'Mejora de Video IA',
        // Image Tools
        aiImageGenerator: 'Generador de Imágenes IA',
        imageToImageAI: 'Imagen a Imagen IA',
        aiImageAspectRatioConverter: 'Ajustador de Tamaño de Imagen IA',
        aiImageUpscaler: 'Mejorador de Imágenes IA',
        aiImageUpscalerDesc: 'Mejora la calidad y nitidez de las imágenes',
        aiImageTranslation: 'Traducción de Imagen IA',
        aiImageRatioConversion: 'Conversión de Proporción de Imagen IA',
        aiImageQualityUpgrade: 'Mejora de Calidad de Imagen IA',
        aiBackgroundChanger: 'Cambiador de Fondo IA',
        aiBackgroundChangerDesc:
            'Reemplaza el fondo de la foto con cualquier escena que desees',
        aiDancingVideoGenerator: 'Generador de videos de baile con IA',
        aiKissingVideoGenerator: 'Generador de videos de besos con IA',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Mejora el realismo del video y la sincronización de audio',
        veo3: 'Veo 3',
        veo3Desc: 'Modelo de generación de video de alta calidad',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Modelo de generación de video rápido',
        sora2: 'Sora 2',
        sora2Desc: 'Simulación realista del mundo y del audio',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'El modelo insignia de 微鲤AI para narrativa de video rápida, cinematográfica y consistente',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'Plataforma de creación de video con IA',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Generación de video sincronizada audiovisual',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Modelo de video multimodal unificado',
        runway: 'Runway',
        runwayDesc: 'Plataforma profesional de edición de video con IA',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'Simulación física sin precedentes, arquitectura híbrida A2D, coherencia temporal cinematográfica',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Generación avanzada de video con IA',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Próxima generación de creación de video con IA',
        seedance: 'Seedance',
        seedanceDesc: 'IA creativa para generación de videos',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Generación de video rápida y de bajo costo',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'Generación de video cinematográfico con control preciso de cámara y guía de fotogramas inicio/fin',
        wanAI: 'Wan AI',
        wanAIDesc: 'Modelo de generación de video Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'Imágenes nítidas, claras y de alta definición',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc:
            'El primer "motor de imágenes por razonamiento" del mundo',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Generación de imágenes compacta y eficiente',
        flux: 'FLUX',
        fluxDesc: 'Modelo de generación de imágenes de alta calidad',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Generación de imágenes consciente del contexto',
        imagen: 'Imagen',
        imagenDesc: 'Generador de imágenes avanzado de Google',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'IA multimodal con potentes capacidades de imagen',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Generación de imágenes impulsada por Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Plataforma creativa de generación de imágenes',
        dreamina: 'Dreamina',
        supportedVideoModels: 'Modelos de Video Compatibles',
        supportedImageModels: 'Modelos de Imagen Compatibles',
        wanAIImageDesc: 'Modelo de Imagen Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'Modelo de imagen IA insignia de ByteDance con tipografía precisa y fusión de múltiples imágenes',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: 'Generación de imágenes IA cinematográficas',
    },
    fr: {
        tagline:
            "Votre plateforme tout-en-un de création de vidéos et d'images IA",
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Outils Vidéo',
        aiEffects: 'AI Effets',
        imageTools: 'Outils Image',
        videoModels: 'Modèles Vidéo',
        imageModels: 'Modèles Image',
        company: 'Entreprise',
        aboutUsLink: 'À Propos',
        contactUs: 'Nous Contacter',
        pricingLink: 'Tarifs',
        faqs: 'FAQ',
        refundPolicy: 'Politique de Remboursement',
        privacyPolicy: 'Politique de Confidentialité',
        termsAndConditions: 'Conditions Générales',
        // Video Tools
        imageToVideoAI: 'Image vers Vidéo IA',
        textToVideoAI: 'Texte vers Vidéo IA',
        aiVideoEditor: 'Éditeur de Vidéo IA',
        aiWatermarkRemoval: 'Suppression de Filigrane IA',
        aiVideoFaceSwap: 'Échange de Visage Vidéo IA',
        aiVideoLipSync: 'Synchronisation Labiale Vidéo IA',
        aiVideoSubtitleErase: 'Suppression de Sous-titres IA',
        aiVideoStylization: 'Stylisation Vidéo IA',
        aiVideoEnhancement: 'Amélioration Vidéo IA',
        // Image Tools
        aiImageGenerator: "Générateur d'Images IA",
        imageToImageAI: 'Image vers Image IA',
        aiImageAspectRatioConverter: "Ajusteur de Taille d'Image IA",
        aiImageUpscaler: "Amélioration d'Image IA",
        aiImageUpscalerDesc: 'Améliore la qualité et la netteté des images',
        aiImageTranslation: "Traduction d'Image IA",
        aiImageRatioConversion: "Conversion de Ratio d'Image IA",
        aiImageQualityUpgrade: "Amélioration de Qualité d'Image IA",
        aiBackgroundChanger: "Changeur d'Arrière-plan IA",
        aiBackgroundChangerDesc:
            "Remplacez l'arrière-plan de la photo par n'importe quelle scène souhaitée",
        aiDancingVideoGenerator: 'Générateur de vidéos de danse IA',
        aiKissingVideoGenerator: 'Générateur de vidéos de baisers IA',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Améliore le réalisme vidéo et la synchronisation audio',
        veo3: 'Veo 3',
        veo3Desc: 'Modèle de génération de vidéos de haute qualité',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Modèle de génération de vidéos rapide',
        sora2: 'Sora 2',
        sora2Desc: 'Simulation réaliste du monde et de l’audio',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'Le modèle phare de 微鲤AI pour une narration vidéo rapide, cinématographique et cohérente',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'Plateforme de création vidéo basée sur l’IA',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Génération vidéo synchronisée audiovisuelle',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Modèle vidéo multimodal unifié',
        runway: 'Runway',
        runwayDesc: 'Plateforme professionnelle de montage vidéo avec IA',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'Simulation physique sans précédent, architecture hybride A2D, cohérence temporelle cinématographique',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Génération vidéo avancée par IA',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Nouvelle génération de création vidéo avec IA',
        seedance: 'Seedance',
        seedanceDesc: 'IA créative pour la génération de vidéos',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Génération vidéo rapide et à faible coût',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'Génération vidéo cinématographique avec contrôle précis de caméra et guidage des images début/fin',
        wanAI: 'Wan AI',
        wanAIDesc: 'Modèle de génération vidéo Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'Visuels nets, précis et haute clarté',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc:
            'Le premier "moteur d’images par raisonnement" au monde',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Génération d’images compacte et haute efficacité',
        flux: 'FLUX',
        fluxDesc: 'Modèle de génération d’images de haute qualité',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Génération d’images sensible au contexte',
        imagen: 'Imagen',
        imagenDesc: 'Solution avancée de génération d’images de Google',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'IA multimodale avec de puissantes capacités d’image',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Générateur d’images propulsé par Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Plateforme créative de génération d’images',
        dreamina: 'Dreamina',
        supportedVideoModels: 'Modèles Vidéo Compatibles',
        supportedImageModels: 'Modèles Image Compatibles',
        wanAIImageDesc: 'Modèle Image Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            "Modèle d'image IA phare de ByteDance avec typographie précise et fusion multi-images",
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: 'Génération d\'images IA cinématographiques',
    },
    de: {
        tagline: 'Ihre All-in-One KI-Video- und Bildgenerierungsplattform',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Video-Tools',
        aiEffects: 'AI Effekte',
        imageTools: 'Bild-Tools',
        videoModels: 'Video-Modelle',
        imageModels: 'Bild-Modelle',
        company: 'Unternehmen',
        aboutUsLink: 'Über Uns',
        contactUs: 'Kontakt',
        pricingLink: 'Preise',
        faqs: 'Häufige Fragen',
        refundPolicy: 'Rückerstattungsrichtlinie',
        privacyPolicy: 'Datenschutzrichtlinie',
        termsAndConditions: 'Allgemeine Geschäftsbedingungen',
        // Video Tools
        imageToVideoAI: 'Bild zu Video KI',
        textToVideoAI: 'Text zu Video KI',
        aiVideoEditor: 'KI-Video-Editor',
        aiWatermarkRemoval: 'KI-Wasserzeichen-Entfernung',
        aiVideoFaceSwap: 'KI-Video-Gesichtstausch',
        aiVideoLipSync: 'KI-Video-Lippensynchronisation',
        aiVideoSubtitleErase: 'KI-Untertitel-Entfernung',
        aiVideoStylization: 'KI-Video-Stylisierung',
        aiVideoEnhancement: 'KI-Video-Verbesserung',
        // Image Tools
        aiImageGenerator: 'KI-Bildgenerator',
        imageToImageAI: 'Bild zu Bild KI',
        aiImageAspectRatioConverter: 'KI-Bildgrößenanpasser',
        aiImageUpscaler: 'KI-Bildverbesserung',
        aiImageUpscalerDesc: 'Verbessert Bildqualität und Schärfe',
        aiImageTranslation: 'KI-Bildübersetzung',
        aiImageRatioConversion: 'KI-Bildverhältnis-Konvertierung',
        aiImageQualityUpgrade: 'KI-Bildqualitätsverbesserung',
        aiBackgroundChanger: 'KI-Hintergrund-Wechsler',
        aiBackgroundChangerDesc:
            'Ersetzen Sie den Fotohintergrund mit jeder gewünschten Szene',
        aiDancingVideoGenerator: 'KI-Tanz-Videogenerator',
        aiKissingVideoGenerator: 'KI-Kuss-Videogenerator',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc:
            'Verbessert den Realismus von Videos und die Audiosynchronisation',
        veo3: 'Veo 3',
        veo3Desc: 'Hochwertiges Video-Generierungsmodell',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Schnelles Video-Generierungsmodell',
        sora2: 'Sora 2',
        sora2Desc: 'Realistische Simulation von Welt und Audio',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'WeryAIs Flaggschiff-Modell für schnelles, filmisches und konsistentes Video-Storytelling',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'KI-basierte Videoerstellungsplattform',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Audiovisuell synchronisierte Videogenerierung',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Einheitliches multimodales Videomodell',
        runway: 'Runway',
        runwayDesc: 'Professionelle KI-Video-Schnittplattform',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'Beispiellose Physiksimulation, A2D-Hybridarchitektur, filmische zeitliche Kohärenz',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Fortgeschrittene KI-Video-Generierung',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Next-Gen KI-Videoerstellungsplattform',
        seedance: 'Seedance',
        seedanceDesc: 'Kreative Video-Generierungs-KI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Schnelle und kostengünstige Video-Generierung',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'Kinematische Videogenerierung mit präziser Kamerasteuerung und Start/Ende-Frame-Führung',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI Video-Generierungsmodell',
        pika22: 'Pika 2.2',
        pika22Desc: 'Gestochen scharf, klar und hochauflösend',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: 'Die weltweit erste „Inference-Bild-Engine“',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Kompakte und effiziente Bildgenerierung',
        flux: 'FLUX',
        fluxDesc: 'Hochwertiges Bildgenerierungsmodell',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Kontextbewusste Bildgenerierung',
        imagen: 'Imagen',
        imagenDesc: 'Googles fortschrittliche Bildgenerierungslösung',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'Multimodale KI mit leistungsstarken Bildfähigkeiten',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Von Qwen unterstützte Bildgenerierung',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Kreative Bildgenerierungsplattform',
        dreamina: 'Dreamina',
        supportedVideoModels: 'Unterstützte Video-Modelle',
        supportedImageModels: 'Unterstützte Bild-Modelle',
        wanAIImageDesc: 'Wan AI Bildgenerierungsmodell',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'ByteDances Flaggschiff-KI-Bildmodell mit präziser Typografie und Multi-Bild-Fusion',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: 'Cinematische KI-Bildgenerierung',
    },
    ru: {
        tagline:
            'Ваша универсальная платформа для создания видео и изображений с ИИ',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Видео Инструменты',
        aiEffects: 'AI Эффекты',
        imageTools: 'Инструменты Изображений',
        videoModels: 'Видео Модели',
        imageModels: 'Модели Изображений',
        company: 'Компания',
        aboutUsLink: 'О Нас',
        contactUs: 'Связаться с Нами',
        pricingLink: 'Цены',
        faqs: 'Часто Задаваемые Вопросы',
        refundPolicy: 'Политика Возврата',
        privacyPolicy: 'Политика Конфиденциальности',
        termsAndConditions: 'Условия Использования',
        // Video Tools
        imageToVideoAI: 'Изображение в Видео ИИ',
        textToVideoAI: 'Текст в Видео ИИ',
        aiVideoEditor: 'ИИ Видео Редактор',
        aiWatermarkRemoval: 'ИИ Удаление Водяных Знаков',
        aiVideoFaceSwap: 'ИИ Замена Лица в Видео',
        aiVideoLipSync: 'ИИ Синхронизация Губ в Видео',
        aiVideoSubtitleErase: 'ИИ Удаление Субтитров',
        aiVideoStylization: 'ИИ Стилизация Видео',
        aiVideoEnhancement: 'ИИ Улучшение Видео',
        // Image Tools
        aiImageGenerator: 'ИИ Генератор Изображений',
        imageToImageAI: 'Изображение в Изображение ИИ',
        aiImageAspectRatioConverter: 'ИИ Настройщик Размера Изображения',
        aiImageUpscaler: 'ИИ Улучшение Изображений',
        aiImageUpscalerDesc: 'Улучшает качество и четкость изображений',
        aiImageTranslation: 'ИИ Перевод Изображений',
        aiImageRatioConversion: 'ИИ Конвертация Пропорций Изображений',
        aiImageQualityUpgrade: 'ИИ Улучшение Качества Изображений',
        aiBackgroundChanger: 'ИИ Сменщик Фона',
        aiBackgroundChangerDesc:
            'Замените фон фотографии на любую желаемую сцену',
        aiDancingVideoGenerator: 'Генератор танцевальных видео с ИИ',
        aiKissingVideoGenerator: 'Генератор видео поцелуев с ИИ',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Улучшает реалистичность видео и синхронизацию звука',
        veo3: 'Veo 3',
        veo3Desc: 'Высококачественная модель генерации видео',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Быстрая модель генерации видео',
        sora2: 'Sora 2',
        sora2Desc: 'Реалистичное моделирование мира и звука',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'Флагманская модель 微鲤AI для быстрого, кинематографичного и последовательного видеоповествования',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'Платформа создания видео на основе ИИ',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Синхронная генерация аудио и видео',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Единая мультимодальная видеомодель',
        runway: 'Runway',
        runwayDesc: 'Профессиональная платформа редактирования видео с ИИ',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'Беспрецедентная физическая симуляция, гибридная архитектура A2D, кинематографическая временная когерентность',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Продвинутая генерация видео с ИИ',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Платформа следующего поколения для создания видео с ИИ',
        seedance: 'Seedance',
        seedanceDesc: 'Креативный ИИ для генерации видео',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Быстрая и недорогая генерация видео',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'Кинематографическая генерация видео с точным управлением камерой и направляющими кадрами начала/конца',
        wanAI: 'Wan AI',
        wanAIDesc: 'Модель генерации видео Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'Чёткое, резкое, высококачественное изображение',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: 'Первый в мире «движок рассуждающей графики»',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Компактная и эффективная генерация изображений',
        flux: 'FLUX',
        fluxDesc: 'Высококачественная модель генерации изображений',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Контекстно-зависимая генерация изображений',
        imagen: 'Imagen',
        imagenDesc: 'Продвинутое решение Google для генерации изображений',
        gpt4o: 'GPT-4o',
        gpt4oDesc:
            'Мультимодальный ИИ с мощными возможностями генерации изображений',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Генерация изображений на базе модели Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Креативная платформа генерации изображений',
        dreamina: 'Dreamina',
        supportedVideoModels: 'Поддерживаемые Видео Модели',
        supportedImageModels: 'Поддерживаемые Модели Изображений',
        wanAIImageDesc: 'Модель Изображения Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'Флагманская AI-модель изображений ByteDance с точной типографикой и слиянием нескольких изображений',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: 'Кинематографическая генерация изображений ИИ',
    },
    pt: {
        tagline:
            'Sua plataforma completa de criação de vídeos e imagens com IA',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Ferramentas de Vídeo',
        aiEffects: 'AI Efeitos',
        imageTools: 'Ferramentas de Imagem',
        videoModels: 'Modelos de Vídeo',
        imageModels: 'Modelos de Imagem',
        company: 'Empresa',
        aboutUsLink: 'Sobre Nós',
        contactUs: 'Entre em Contato',
        pricingLink: 'Preços',
        faqs: 'Perguntas Frequentes',
        refundPolicy: 'Política de Reembolso',
        privacyPolicy: 'Política de Privacidade',
        termsAndConditions: 'Termos e Condições',
        // Video Tools
        imageToVideoAI: 'Imagem para Vídeo IA',
        textToVideoAI: 'Texto para Vídeo IA',
        aiVideoEditor: 'Editor de Vídeo IA',
        aiWatermarkRemoval: "Remoção de Marca d'Água IA",
        aiVideoFaceSwap: 'Troca de Rosto em Vídeo IA',
        aiVideoLipSync: 'Sincronização Labial em Vídeo IA',
        aiVideoSubtitleErase: 'Remoção de Legendas IA',
        aiVideoStylization: 'Estilização de Vídeo IA',
        aiVideoEnhancement: 'Melhoria de Vídeo IA',
        // Image Tools
        aiImageGenerator: 'Gerador de Imagens IA',
        imageToImageAI: 'Imagem para Imagem IA',
        aiImageAspectRatioConverter: 'Ajustador de Tamanho de Imagem IA',
        aiImageUpscaler: 'Melhoria de Imagem IA',
        aiImageUpscalerDesc: 'Melhora a qualidade e nitidez das imagens',
        aiImageTranslation: 'Tradução de Imagem IA',
        aiImageRatioConversion: 'Conversão de Proporção de Imagem IA',
        aiImageQualityUpgrade: 'Melhoria de Qualidade de Imagem IA',
        aiBackgroundChanger: 'Mudador de Fundo IA',
        aiBackgroundChangerDesc:
            'Substitua o fundo da foto por qualquer cena desejada',
        aiDancingVideoGenerator: 'Gerador de vídeos de dança com IA',
        aiKissingVideoGenerator: 'Gerador de vídeos de beijos com IA',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Melhora o realismo do vídeo e a sincronização de áudio',
        veo3: 'Veo 3',
        veo3Desc: 'Modelo de geração de vídeo de alta qualidade',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Modelo de geração de vídeo rápido',
        sora2: 'Sora 2',
        sora2Desc: 'Simulação realista de mundo e áudio',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'O modelo principal da 微鲤AI para narrativa de vídeo rápida, cinematográfica e consistente',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'Plataforma de criação de vídeos com IA',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Geração de vídeo sincronizada audiovisual',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Modelo de vídeo multimodal unificado',
        runway: 'Runway',
        runwayDesc: 'Plataforma profissional de edição de vídeo com IA',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'Simulação física sem precedentes, arquitetura híbrida A2D, coerência temporal cinematográfica',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Geração avançada de vídeos com IA',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Próxima geração de criação de vídeos com IA',
        seedance: 'Seedance',
        seedanceDesc: 'IA criativa para geração de vídeos',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Geração de vídeos rápida e de baixo custo',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'Geração de vídeo cinematográfico com controle preciso de câmera e orientação de quadros início/fim',
        wanAI: 'Wan AI',
        wanAIDesc: 'Modelo de geração de vídeos Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'Visuais nítidos, claros e de alta definição',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc:
            'O primeiro "motor de imagens por inferência" do mundo',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Geração de imagens compacta e eficiente',
        flux: 'FLUX',
        fluxDesc: 'Modelo de geração de imagens de alta qualidade',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Geração de imagens ciente do contexto',
        imagen: 'Imagen',
        imagenDesc: 'Solução avançada de geração de imagens do Google',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'IA multimodal com fortes capacidades de imagem',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Geração de imagens alimentada por Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Plataforma criativa de geração de imagens',
        dreamina: 'Dreamina',
        supportedVideoModels: 'Modelos de Vídeo Compatíveis',
        supportedImageModels: 'Modelos de Imagem Compatíveis',
        wanAIImageDesc: 'Modelo de Imagem Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'Modelo de imagem IA principal da ByteDance com tipografia precisa e fusão de múltiplas imagens',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: 'Geração de imagens IA cinematográficas',
    },
    it: {
        tagline:
            'La tua piattaforma completa per la creazione di video e immagini con IA',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Strumenti Video',
        aiEffects: 'AI Effetti',
        imageTools: 'Strumenti Immagine',
        videoModels: 'Modelli Video',
        imageModels: 'Modelli Immagine',
        company: 'Azienda',
        aboutUsLink: 'Chi Siamo',
        contactUs: 'Contattaci',
        pricingLink: 'Prezzi',
        faqs: 'Domande Frequenti',
        refundPolicy: 'Politica di Rimborso',
        privacyPolicy: 'Politica sulla Privacy',
        termsAndConditions: 'Termini e Condizioni',
        // Video Tools
        imageToVideoAI: 'Immagine a Video IA',
        textToVideoAI: 'Testo a Video IA',
        aiVideoEditor: 'Editor Video IA',
        aiWatermarkRemoval: 'Rimozione Filigrana IA',
        aiVideoFaceSwap: 'Scambio Volto Video IA',
        aiVideoLipSync: 'Sincronizzazione Labbra Video IA',
        aiVideoSubtitleErase: 'Rimozione Sottotitoli IA',
        aiVideoStylization: 'Stilizzazione Video IA',
        aiVideoEnhancement: 'Miglioramento Video IA',
        // Image Tools
        aiImageGenerator: 'Generatore Immagini IA',
        imageToImageAI: 'Immagine a Immagine IA',
        aiImageAspectRatioConverter: 'Regolatore Dimensione Immagine IA',
        aiImageUpscaler: 'Miglioramento Immagini IA',
        aiImageUpscalerDesc:
            'Migliora la qualità e la nitidezza delle immagini',
        aiImageTranslation: 'Traduzione Immagine IA',
        aiImageRatioConversion: 'Conversione Proporzione Immagine IA',
        aiImageQualityUpgrade: 'Miglioramento Qualità Immagine IA',
        aiBackgroundChanger: 'Cambio Sfondo IA',
        aiBackgroundChangerDesc:
            'Sostituisci lo sfondo della foto con qualsiasi scena desideri',
        aiDancingVideoGenerator: 'Generatore di video di danza IA',
        aiKissingVideoGenerator: 'Generatore di video di baci IA',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Migliora il realismo del video e la sincronizzazione audio',
        veo3: 'Veo 3',
        veo3Desc: 'Modello di generazione video di alta qualità',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Modello di generazione video veloce',
        sora2: 'Sora 2',
        sora2Desc: 'Simulazione realistica del mondo e dell’audio',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'Il modello di punta di 微鲤AI per una narrazione video veloce, cinematografica e coerente',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'Piattaforma di creazione video basata sull’IA',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Generazione video sincronizzata audiovisiva',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Modello video multimodale unificato',
        runway: 'Runway',
        runwayDesc: 'Piattaforma professionale di editing video con IA',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'Simulazione fisica senza precedenti, architettura ibrida A2D, coerenza temporale cinematografica',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Generazione video avanzata con IA',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc:
            'Piattaforma di nuova generazione per la creazione di video con IA',
        seedance: 'Seedance',
        seedanceDesc: 'IA creativa per la generazione di video',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Generazione video veloce e a basso costo',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'Generazione video cinematografica con controllo preciso della telecamera e guida fotogrammi inizio/fine',
        wanAI: 'Wan AI',
        wanAIDesc: 'Modello di generazione video Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'Immagini nitide, chiare e ad alta definizione',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc:
            'Il primo "motore di immagini basato sul ragionamento" al mondo',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Generazione di immagini compatta ed efficiente',
        flux: 'FLUX',
        fluxDesc: 'Modello di generazione di immagini di alta qualità',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Generazione di immagini consapevole del contesto',
        imagen: 'Imagen',
        imagenDesc: 'Soluzione avanzata di generazione di immagini di Google',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'IA multimodale con potenti capacità di immagine',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Generatore di immagini basato su Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Piattaforma creativa di generazione di immagini',
        dreamina: 'Dreamina',
        supportedVideoModels: 'Modelli Video Compatibili',
        supportedImageModels: 'Modelli Immagine Compatibili',
        wanAIImageDesc: 'Modello Immagine Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'Modello di immagine IA di punta di ByteDance con tipografia precisa e fusione multi-immagine',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: 'Generazione di immagini IA cinematografiche',
    },
    ar: {
        tagline: 'منصتك الشاملة لإنشاء الفيديوهات والصور بالذكاء الاصطناعي',
        copyright: 'حقوق النشر © 2025 微鲤AI',
        videoTools: 'أدوات الفيديو',
        aiEffects: 'AI تأثيرات',
        imageTools: 'أدوات الصور',
        videoModels: 'نماذج الفيديو',
        imageModels: 'نماذج الصور',
        company: 'الشركة',
        aboutUsLink: 'من نحن',
        contactUs: 'اتصل بنا',
        pricingLink: 'الأسعار',
        faqs: 'الأسئلة الشائعة',
        refundPolicy: 'سياسة الاسترداد',
        privacyPolicy: 'سياسة الخصوصية',
        termsAndConditions: 'الشروط والأحكام',
        // Video Tools
        imageToVideoAI: 'صورة إلى فيديو ذكاء اصطناعي',
        textToVideoAI: 'نص إلى فيديو ذكاء اصطناعي',
        aiVideoEditor: 'محرر فيديو ذكاء اصطناعي',
        aiWatermarkRemoval: 'إزالة العلامة المائية بالذكاء الاصطناعي',
        aiVideoFaceSwap: 'تبديل الوجه في الفيديو بالذكاء الاصطناعي',
        aiVideoLipSync: 'مزامنة الشفاه في الفيديو بالذكاء الاصطناعي',
        aiVideoSubtitleErase: 'إزالة الترجمات بالذكاء الاصطناعي',
        aiVideoStylization: 'تصميم الفيديو بالذكاء الاصطناعي',
        aiVideoEnhancement: 'تحسين الفيديو بالذكاء الاصطناعي',
        // Image Tools
        aiImageGenerator: 'مولد الصور بالذكاء الاصطناعي',
        imageToImageAI: 'صورة إلى صورة ذكاء اصطناعي',
        aiImageAspectRatioConverter: 'أداة ضبط حجم الصورة بالذكاء الاصطناعي',
        aiImageUpscaler: 'تحسين الصورة بالذكاء الاصطناعي',
        aiImageUpscalerDesc: 'ترقية جودة الصورة وتعزيز الوضوح',
        aiImageTranslation: 'ترجمة الصور بالذكاء الاصطناعي',
        aiImageRatioConversion: 'تحويل نسبة الصور بالذكاء الاصطناعي',
        aiImageQualityUpgrade: 'تحسين جودة الصور بالذكاء الاصطناعي',
        aiBackgroundChanger: 'مغير الخلفية بالذكاء الاصطناعي',
        aiBackgroundChangerDesc: 'استبدل خلفية الصورة بأي مشهد تريده',
        aiDancingVideoGenerator: 'مولد فيديو الرقص بالذكاء الاصطناعي',
        aiKissingVideoGenerator: 'مولد فيديو القبلات بالذكاء الاصطناعي',
        // Video Models
        veo31Link: 'Veo 3.1',
        veo31Desc: 'يعزز واقعية الفيديو ومزامنة الصوت',
        veo3: 'Veo 3',
        veo3Desc: 'نموذج عالي الجودة لتوليد الفيديو',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'نموذج سريع لتوليد الفيديو',
        sora2: 'Sora 2',
        sora2Desc: 'محاكاة واقعية للعالم والصوت',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'النموذج الرائد من 微鲤AI لسرد فيديو سريع وسينمائي ومتسق',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'منصة إنشاء فيديوهات بالذكاء الاصطناعي',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'توليد فيديو متزامن سمعي بصري',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'نموذج فيديو متعدد الوسائط موحد',
        runway: 'Runway',
        runwayDesc: 'منصة احترافية لتحرير الفيديو بالذكاء الاصطناعي',
        runway45: 'Runway Gen-4.5',
        runway45Desc:
            'محاكاة فيزيائية غير مسبوقة، بنية هجينة A2D، تماسك زمني سينمائي',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'توليد متقدم للفيديو بالذكاء الاصطناعي',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'جيل جديد من إنشاء الفيديوهات بالذكاء الاصطناعي',
        seedance: 'Seedance',
        seedanceDesc: 'ذكاء اصطناعي إبداعي لتوليد الفيديوهات',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'توليد فيديوهات سريع ومنخفض التكلفة',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc:
            'توليد فيديو سينمائي مع تحكم دقيق بالكاميرا وتوجيه إطارات البداية/النهاية',
        wanAI: 'Wan AI',
        wanAIDesc: 'نموذج توليد فيديوهات Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'صور واضحة وحادة وعالية الدقة',
        // Image Models
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: 'أول "محرك صور قائم على الاستدلال" في العالم',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'توليد صور مدمج وفعّال',
        flux: 'FLUX',
        fluxDesc: 'نموذج عالي الجودة لتوليد الصور',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'توليد صور واعٍ للسياق',
        imagen: 'Imagen',
        imagenDesc: 'حل متقدم من Google لتوليد الصور',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'ذكاء اصطناعي متعدّد الوسائط بقدرات قوية في الصور',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'توليد صور مدعوم بنموذج Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'منصة إبداعية لتوليد الصور',
        dreamina: 'Dreamina',
        supportedVideoModels: 'نماذج الفيديو المدعومة',
        supportedImageModels: 'نماذج الصور المدعومة',
        wanAIImageDesc: 'نموذج إنشاء الصور Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc:
            'نموذج الصور الرائد من ByteDance مع طباعة دقيقة ودمج متعدد الصور',
            nanoBananaProLink: 'Nano Banana Pro',
            dreaminaDesc: 'توليد صور سينمائية بالذكاء الاصطناعي',
    },
    // 泰语
    th: {
        tagline: 'แพลตฟอร์มสร้างวิดีโอและรูปภาพ AI ครบวงจรของคุณ',
        copyright: 'ลิขสิทธิ์ © 2025 微鲤AI',
        videoTools: 'เครื่องมือวิดีโอ',
        aiEffects: 'เอฟเฟกต์ AI',
        imageTools: 'เครื่องมือรูปภาพ',
        videoModels: 'โมเดลวิดีโอ',
        imageModels: 'โมเดลรูปภาพ',
        company: 'บริษัท',
        aboutUsLink: 'เกี่ยวกับเรา',
        contactUs: 'ติดต่อเรา',
        pricingLink: 'ราคา',
        faqs: 'คำถามที่พบบ่อย',
        refundPolicy: 'นโยบายการคืนเงิน',
        privacyPolicy: 'นโยบายความเป็นส่วนตัว',
        termsAndConditions: 'ข้อกำหนดและเงื่อนไข',
        imageToVideoAI: 'รูปภาพเป็นวิดีโอ AI',
        textToVideoAI: 'ข้อความเป็นวิดีโอ AI',
        aiVideoEditor: 'ตัดต่อวิดีโอ AI',
        aiWatermarkRemoval: 'ลบลายน้ำ AI',
        aiVideoFaceSwap: 'สลับใบหน้าวิดีโอ AI',
        aiVideoLipSync: 'ซิงค์ปากวิดีโอ AI',
        aiVideoSubtitleErase: 'ลบคำบรรยาย AI',
        aiVideoStylization: 'สไตล์วิดีโอ AI',
        aiVideoEnhancement: 'เพิ่มคุณภาพวิดีโอ AI',
        aiImageGenerator: 'สร้างรูปภาพ AI',
        imageToImageAI: 'รูปภาพเป็นรูปภาพ AI',
        aiImageAspectRatioConverter: 'ปรับขนาดรูปภาพ AI',
        aiImageUpscaler: 'เพิ่มคุณภาพรูปภาพ AI',
        aiImageUpscalerDesc: 'ขยาย ลดสัญญาณรบกวน และกู้คืนรูปภาพเบลอในคลิกเดียว',
        aiImageTranslation: 'แปลรูปภาพ AI',
        aiImageRatioConversion: 'แปลงอัตราส่วนรูปภาพ AI',
        aiImageQualityUpgrade: 'อัปเกรดคุณภาพรูปภาพ AI',
        aiBackgroundChanger: 'เปลี่ยนพื้นหลัง AI',
        aiBackgroundChangerDesc: 'เปลี่ยนพื้นหลังรูปภาพด้วยฉากที่คุณต้องการ',
        aiDancingVideoGenerator: 'สร้างวิดีโอเต้นรำ AI',
        aiKissingVideoGenerator: 'สร้างวิดีโอจูบ AI',
        veo31Link: 'Veo 3.1',
        veo31Desc: 'เพิ่มความสมจริงและการซิงค์เสียง',
        veo3: 'Veo 3',
        veo3Desc: 'โมเดลสร้างวิดีโอคุณภาพสูง',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'โมเดลสร้างวิดีโอความเร็วสูง',
        sora2: 'Sora 2',
        sora2Desc: 'จำลองโลกจริงและเสียง',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'โมเดลเรือธงของ 微鲤AI สำหรับการเล่าเรื่องวิดีโอที่รวดเร็ว ภาพยนตร์ และสม่ำเสมอ',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'แพลตฟอร์มสร้างวิดีโอ AI',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'สร้างวิดีโอซิงค์ภาพและเสียง',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'โมเดลวิดีโอมัลติโมดัลรวม',
        runway: 'Runway',
        runwayDesc: 'แพลตฟอร์มตัดต่อวิดีโอ AI ระดับมืออาชีพ',
        runway45: 'Runway Gen-4.5',
        runway45Desc: 'การจำลองฟิสิกส์ที่ไม่เคยมีมาก่อน สถาปัตยกรรมไฮบริด A2D ความต่อเนื่องของเวลาระดับภาพยนตร์',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'สร้างวิดีโอ AI ขั้นสูง',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'การสร้างวิดีโอ AI รุ่นถัดไป',
        seedance: 'Seedance',
        seedanceDesc: 'AI สร้างวิดีโอสร้างสรรค์',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'สร้างวิดีโอความเร็วสูงต้นทุนต่ำ',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc: 'สร้างวิดีโอระดับภาพยนตร์พร้อมการควบคุมกล้องที่แม่นยำ',
        wanAI: 'Wan AI',
        wanAIDesc: 'โมเดลสร้างวิดีโอ Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'ภาพคมชัด ชัดเจน คุณภาพสูง',
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: '"เครื่องยนต์ภาพอนุมาน" แรกของโลก',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'สร้างภาพขนาดกะทัดรัดและมีประสิทธิภาพ',
        flux: 'FLUX',
        fluxDesc: 'โมเดลสร้างภาพคุณภาพสูง',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'สร้างภาพที่เข้าใจบริบท',
        imagen: 'Imagen',
        imagenDesc: 'การสร้างภาพขั้นสูงของ Google',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'AI มัลติโมดัลพร้อมความสามารถด้านภาพ',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'สร้างภาพด้วย Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'แพลตฟอร์มสร้างภาพสร้างสรรค์',
        dreamina: 'Dreamina',
        dreaminaDesc: 'สร้างภาพ AI ระดับภาพยนตร์',
        supportedVideoModels: 'โมเดลวิดีโอที่รองรับ',
        supportedImageModels: 'โมเดลรูปภาพที่รองรับ',
        wanAIImageDesc: 'โมเดลสร้างภาพ Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc: 'โมเดลภาพ AI เรือธงของ ByteDance พร้อมการเรนเดอร์ข้อความที่แม่นยำและการรวมหลายภาพ',
            nanoBananaProLink: 'Nano Banana Pro',
    },
    // 丹麦语
    da: {
        tagline: 'Din alt-i-én AI video- og billedskabelsesplatform',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Videoværktøjer',
        aiEffects: 'AI Effekter',
        imageTools: 'Billedværktøjer',
        videoModels: 'Videomodeller',
        imageModels: 'Billedmodeller',
        company: 'Virksomhed',
        aboutUsLink: 'Om os',
        contactUs: 'Kontakt os',
        pricingLink: 'Priser',
        faqs: 'FAQ',
        refundPolicy: 'Refusionspolitik',
        privacyPolicy: 'Privatlivspolitik',
        termsAndConditions: 'Vilkår og betingelser',
        imageToVideoAI: 'Billede til video AI',
        textToVideoAI: 'Tekst til video AI',
        aiVideoEditor: 'AI videoredigering',
        aiWatermarkRemoval: 'AI vandmærkefjernelse',
        aiVideoFaceSwap: 'AI videoansigtsbytte',
        aiVideoLipSync: 'AI video læbesynkronisering',
        aiVideoSubtitleErase: 'AI undertekstfjernelse',
        aiVideoStylization: 'AI videostilisering',
        aiVideoEnhancement: 'AI videoforbedring',
        aiImageGenerator: 'AI billedgenerator',
        imageToImageAI: 'Billede til billede AI',
        aiImageAspectRatioConverter: 'AI billedstørrelsesændrer',
        aiImageUpscaler: 'AI billedopskalering',
        aiImageUpscalerDesc: 'Opskaler, afstøj og gendan slørede fotos med ét klik',
        aiImageTranslation: 'AI billedoversættelse',
        aiImageRatioConversion: 'AI billedforholdskonvertering',
        aiImageQualityUpgrade: 'AI billedkvalitetsforbedring',
        aiBackgroundChanger: 'AI baggrundsændrer',
        aiBackgroundChangerDesc: 'Erstat fotobaggrunde med enhver scene du ønsker',
        aiDancingVideoGenerator: 'AI dansevideogenerator',
        aiKissingVideoGenerator: 'AI kysvideogenerator',
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Forbedret realisme og lydsynkronisering',
        veo3: 'Veo 3',
        veo3Desc: 'Højkvalitets videogenereringsmodel',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Hurtig videogenereringsmodel',
        sora2: 'Sora 2',
        sora2Desc: 'Realistisk verden- og lydsimulering',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'WeryAIs flagskibsmodel til hurtig, filmisk og konsistent videofortælling',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI videoskabelsesplatform',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Audiovisuel synkroniseret videogenerering',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Samlet multimodal videomodel',
        runway: 'Runway',
        runwayDesc: 'Professionel AI videoredigeringsplatform',
        runway45: 'Runway Gen-4.5',
        runway45Desc: 'Hidtil uset fysiksimulering, A2D hybridarkitektur, filmisk tidsmæssig sammenhæng',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Avanceret AI videogenerering',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Næste generations AI videoskabelse',
        seedance: 'Seedance',
        seedanceDesc: 'Kreativ videogenereringsAI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Højhastigheds lavpris videogenerering',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc: 'Filmisk videogenerering med præcis kamerakontrol',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI videogenereringsmodel',
        pika22: 'Pika 2.2',
        pika22Desc: 'Skarpe, klare billeder i høj kvalitet',
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: 'Verdens første "inference billedmotor"',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Kompakt og effektiv billedgenerering',
        flux: 'FLUX',
        fluxDesc: 'Højkvalitets billedgenereringsmodel',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Kontekstbevidst billedgenerering',
        imagen: 'Imagen',
        imagenDesc: 'Googles avancerede billedgenerering',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'Multimodal AI med billedkapaciteter',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen-drevet billedgenerering',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Kreativ billedgenereringsplatform',
        dreamina: 'Dreamina',
        dreaminaDesc: 'Filmisk AI billedgenerering',
        supportedVideoModels: 'Understøttede videomodeller',
        supportedImageModels: 'Understøttede billedmodeller',
        wanAIImageDesc: 'Wan AI billedgenereringsmodel',
        seedream45: 'Seedream 4.5',
        seedream45Desc: 'ByteDances flagskibs AI billedmodel med præcis typografi og multi-billede fusion',
            nanoBananaProLink: 'Nano Banana Pro',
    },
    // 挪威语
    no: {
        tagline: 'Din alt-i-ett AI video- og bildeskapingsplattform',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Videoverktøy',
        aiEffects: 'AI Effekter',
        imageTools: 'Bildeverktøy',
        videoModels: 'Videomodeller',
        imageModels: 'Bildemodeller',
        company: 'Selskap',
        aboutUsLink: 'Om oss',
        contactUs: 'Kontakt oss',
        pricingLink: 'Priser',
        faqs: 'FAQ',
        refundPolicy: 'Refusjonspolitikk',
        privacyPolicy: 'Personvernpolicy',
        termsAndConditions: 'Vilkår og betingelser',
        imageToVideoAI: 'Bilde til video AI',
        textToVideoAI: 'Tekst til video AI',
        aiVideoEditor: 'AI videoredigering',
        aiWatermarkRemoval: 'AI vannmerkefjerning',
        aiVideoFaceSwap: 'AI video ansiktsbytte',
        aiVideoLipSync: 'AI video leppesynkronisering',
        aiVideoSubtitleErase: 'AI undertekstfjerning',
        aiVideoStylization: 'AI videostilisering',
        aiVideoEnhancement: 'AI videoforbedring',
        aiImageGenerator: 'AI bildegenerator',
        imageToImageAI: 'Bilde til bilde AI',
        aiImageAspectRatioConverter: 'AI bildestørrelsesendrer',
        aiImageUpscaler: 'AI bildeoppskalering',
        aiImageUpscalerDesc: 'Oppskalér, fjern støy og gjenopprett uskarpe bilder med ett klikk',
        aiImageTranslation: 'AI bildeoversettelse',
        aiImageRatioConversion: 'AI bildeforholdskonvertering',
        aiImageQualityUpgrade: 'AI bildekvalitetsforbedring',
        aiBackgroundChanger: 'AI bakgrunnsendrer',
        aiBackgroundChangerDesc: 'Erstatt fotobakgrunner med hvilken som helst scene du ønsker',
        aiDancingVideoGenerator: 'AI dansevideogenerator',
        aiKissingVideoGenerator: 'AI kyssvideogenerator',
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Forbedret realisme og lydsynkronisering',
        veo3: 'Veo 3',
        veo3Desc: 'Høykvalitets videogenereringsmodell',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Rask videogenereringsmodell',
        sora2: 'Sora 2',
        sora2Desc: 'Realistisk verden- og lydsimulering',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'WeryAIs flaggskipmodell for rask, filmisk og konsistent videofortelling',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI videoskapingsplattform',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Audiovisuell synkronisert videogenerering',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Samlet multimodal videomodell',
        runway: 'Runway',
        runwayDesc: 'Profesjonell AI videoredigeringsplattform',
        runway45: 'Runway Gen-4.5',
        runway45Desc: 'Enestående fysikksimulering, A2D hybridarkitektur, filmisk tidsmessig sammenheng',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Avansert AI videogenerering',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Neste generasjons AI videoskaping',
        seedance: 'Seedance',
        seedanceDesc: 'Kreativ videogenereringsAI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Høyhastighets lavkost videogenerering',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc: 'Filmisk videogenerering med presis kamerakontroll',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI videogenereringsmodell',
        pika22: 'Pika 2.2',
        pika22Desc: 'Skarpe, klare bilder i høy kvalitet',
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: 'Verdens første "inference bildemotor"',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Kompakt og effektiv bildegenerering',
        flux: 'FLUX',
        fluxDesc: 'Høykvalitets bildegenereringsmodell',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Kontekstbevisst bildegenerering',
        imagen: 'Imagen',
        imagenDesc: 'Googles avanserte bildegenerering',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'Multimodal AI med bildekapasiteter',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen-drevet bildegenerering',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Kreativ bildegenereringsplattform',
        dreamina: 'Dreamina',
        dreaminaDesc: 'Filmisk AI bildegenerering',
        supportedVideoModels: 'Støttede videomodeller',
        supportedImageModels: 'Støttede bildemodeller',
        wanAIImageDesc: 'Wan AI bildegenereringsmodell',
        seedream45: 'Seedream 4.5',
        seedream45Desc: 'ByteDances flaggskip AI bildemodell med presis typografi og multi-bilde fusjon',
            nanoBananaProLink: 'Nano Banana Pro',
    },
    // 荷兰语
    nl: {
        tagline: 'Uw alles-in-één AI video- en beeldcreatieplatform',
        copyright: 'Copyright © 2025 微鲤AI',
        videoTools: 'Videotools',
        aiEffects: 'AI Effecten',
        imageTools: 'Afbeeldingstools',
        videoModels: 'Videomodellen',
        imageModels: 'Afbeeldingsmodellen',
        company: 'Bedrijf',
        aboutUsLink: 'Over ons',
        contactUs: 'Contact',
        pricingLink: 'Prijzen',
        faqs: 'FAQ',
        refundPolicy: 'Restitutiebeleid',
        privacyPolicy: 'Privacybeleid',
        termsAndConditions: 'Algemene voorwaarden',
        imageToVideoAI: 'Afbeelding naar video AI',
        textToVideoAI: 'Tekst naar video AI',
        aiVideoEditor: 'AI video-editor',
        aiWatermarkRemoval: 'AI watermerkverwijdering',
        aiVideoFaceSwap: 'AI video gezichtswissel',
        aiVideoLipSync: 'AI video lipsynchronisatie',
        aiVideoSubtitleErase: 'AI ondertitelverwijdering',
        aiVideoStylization: 'AI videostilering',
        aiVideoEnhancement: 'AI videoverbetering',
        aiImageGenerator: 'AI afbeeldingsgenerator',
        imageToImageAI: 'Afbeelding naar afbeelding AI',
        aiImageAspectRatioConverter: 'AI afbeeldingsgrootte aanpasser',
        aiImageUpscaler: 'AI afbeeldingsopschaling',
        aiImageUpscalerDesc: 'Opschalen, ruisonderdrukking en onscherpe foto\'s herstellen met één klik',
        aiImageTranslation: 'AI afbeeldingsvertaling',
        aiImageRatioConversion: 'AI afbeeldingsverhoudingsconversie',
        aiImageQualityUpgrade: 'AI afbeeldingskwaliteitsverbetering',
        aiBackgroundChanger: 'AI achtergrondwisselaar',
        aiBackgroundChangerDesc: 'Vervang fotoachtergronden met elke gewenste scène',
        aiDancingVideoGenerator: 'AI dansvideogenerator',
        aiKissingVideoGenerator: 'AI kusvideogenerator',
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Verbeterd realisme en audiosynchronisatie',
        veo3: 'Veo 3',
        veo3Desc: 'Hoogwaardige videogeneratiemodel',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Snel videogeneratiemodel',
        sora2: 'Sora 2',
        sora2Desc: 'Realistische wereld- en audiosimulatie',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: '微鲤AI\'s vlaggenschipmodel voor snelle, filmische en consistente videovertelling',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI videocreatieplatform',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Audiovisueel gesynchroniseerde videogeneratie',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Geünificeerd multimodaal videomodel',
        runway: 'Runway',
        runwayDesc: 'Professioneel AI videobewerkingsplatform',
        runway45: 'Runway Gen-4.5',
        runway45Desc: 'Ongekende fysicasimulatie, A2D hybride architectuur, filmische temporele coherentie',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Geavanceerde AI videogeneratie',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Volgende generatie AI videocreatie',
        seedance: 'Seedance',
        seedanceDesc: 'Creatieve videogeneratie AI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Hogesnelheids lagekosten videogeneratie',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc: 'Filmische videogeneratie met precieze cameracontrole',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI videogeneratiemodel',
        pika22: 'Pika 2.2',
        pika22Desc: 'Scherpe, heldere beelden van hoge kwaliteit',
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: '\'s Werelds eerste "inference beeldmotor"',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Compacte en efficiënte beeldgeneratie',
        flux: 'FLUX',
        fluxDesc: 'Hoogwaardige beeldgeneratiemodel',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Contextbewuste beeldgeneratie',
        imagen: 'Imagen',
        imagenDesc: 'Google\'s geavanceerde beeldgeneratie',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'Multimodale AI met beeldcapaciteiten',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen-aangedreven beeldgeneratie',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Creatief beeldgeneratieplatform',
        dreamina: 'Dreamina',
        dreaminaDesc: 'Filmische AI beeldgeneratie',
        supportedVideoModels: 'Ondersteunde videomodellen',
        supportedImageModels: 'Ondersteunde afbeeldingsmodellen',
        wanAIImageDesc: 'Wan AI beeldgeneratiemodel',
        seedream45: 'Seedream 4.5',
        seedream45Desc: 'ByteDance\'s vlaggenschip AI beeldmodel met precieze typografie en multi-beeld fusie',
            nanoBananaProLink: 'Nano Banana Pro',
    },
    // 印尼语
    id: {
        tagline: 'Platform pembuatan video dan gambar AI lengkap Anda',
        copyright: 'Hak Cipta © 2025 微鲤AI',
        videoTools: 'Alat Video',
        aiEffects: 'Efek AI',
        imageTools: 'Alat Gambar',
        videoModels: 'Model Video',
        imageModels: 'Model Gambar',
        company: 'Perusahaan',
        aboutUsLink: 'Tentang Kami',
        contactUs: 'Hubungi Kami',
        pricingLink: 'Harga',
        faqs: 'FAQ',
        refundPolicy: 'Kebijakan Pengembalian Dana',
        privacyPolicy: 'Kebijakan Privasi',
        termsAndConditions: 'Syarat dan Ketentuan',
        imageToVideoAI: 'Gambar ke Video AI',
        textToVideoAI: 'Teks ke Video AI',
        aiVideoEditor: 'Editor Video AI',
        aiWatermarkRemoval: 'Penghapusan Watermark AI',
        aiVideoFaceSwap: 'Tukar Wajah Video AI',
        aiVideoLipSync: 'Sinkronisasi Bibir Video AI',
        aiVideoSubtitleErase: 'Penghapusan Subtitle AI',
        aiVideoStylization: 'Stilisasi Video AI',
        aiVideoEnhancement: 'Peningkatan Video AI',
        aiImageGenerator: 'Generator Gambar AI',
        imageToImageAI: 'Gambar ke Gambar AI',
        aiImageAspectRatioConverter: 'Pengubah Ukuran Gambar AI',
        aiImageUpscaler: 'Peningkat Gambar AI',
        aiImageUpscalerDesc: 'Perbesar, kurangi noise, dan pulihkan foto buram dengan satu klik',
        aiImageTranslation: 'Terjemahan Gambar AI',
        aiImageRatioConversion: 'Konversi Rasio Gambar AI',
        aiImageQualityUpgrade: 'Peningkatan Kualitas Gambar AI',
        aiBackgroundChanger: 'Pengubah Latar Belakang AI',
        aiBackgroundChangerDesc: 'Ganti latar belakang foto dengan adegan apa pun yang Anda inginkan',
        aiDancingVideoGenerator: 'Generator Video Tarian AI',
        aiKissingVideoGenerator: 'Generator Video Ciuman AI',
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Realisme dan sinkronisasi audio yang ditingkatkan',
        veo3: 'Veo 3',
        veo3Desc: 'Model generasi video berkualitas tinggi',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Model generasi video cepat',
        sora2: 'Sora 2',
        sora2Desc: 'Simulasi dunia dan audio realistis',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'Model andalan 微鲤AI untuk penceritaan video yang cepat, sinematik, dan konsisten',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'Platform pembuatan video AI',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Generasi video tersinkronisasi audiovisual',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Model video multimodal terpadu',
        runway: 'Runway',
        runwayDesc: 'Platform pengeditan video AI profesional',
        runway45: 'Runway Gen-4.5',
        runway45Desc: 'Simulasi fisika yang belum pernah ada sebelumnya, arsitektur hibrid A2D, koherensi temporal sinematik',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Generasi video AI tingkat lanjut',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Pembuatan video AI generasi berikutnya',
        seedance: 'Seedance',
        seedanceDesc: 'AI generasi video kreatif',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Generasi video kecepatan tinggi biaya rendah',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc: 'Generasi video sinematik dengan kontrol kamera yang presisi',
        wanAI: 'Wan AI',
        wanAIDesc: 'Model generasi video Wan AI',
        pika22: 'Pika 2.2',
        pika22Desc: 'Visual tajam, jelas, dan berkualitas tinggi',
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: '"Mesin gambar inferensi" pertama di dunia',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Generasi gambar kompak dan efisien',
        flux: 'FLUX',
        fluxDesc: 'Model generasi gambar berkualitas tinggi',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Generasi gambar sadar konteks',
        imagen: 'Imagen',
        imagenDesc: 'Generasi gambar canggih dari Google',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'AI multimodal dengan kemampuan gambar',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Generasi gambar bertenaga Qwen',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Platform generasi gambar kreatif',
        dreamina: 'Dreamina',
        dreaminaDesc: 'Generasi gambar AI sinematik',
        supportedVideoModels: 'Model Video yang Didukung',
        supportedImageModels: 'Model Gambar yang Didukung',
        wanAIImageDesc: 'Model generasi gambar Wan AI',
        seedream45: 'Seedream 4.5',
        seedream45Desc: 'Model gambar AI andalan ByteDance dengan tipografi presisi dan fusi multi-gambar',
            nanoBananaProLink: 'Nano Banana Pro',
    },
    // 土耳其语
    tr: {
        tagline: 'Hepsi bir arada AI video ve görsel oluşturma platformunuz',
        copyright: 'Telif Hakkı © 2025 微鲤AI',
        videoTools: 'Video Araçları',
        aiEffects: 'AI Efektler',
        imageTools: 'Görsel Araçları',
        videoModels: 'Video Modelleri',
        imageModels: 'Görsel Modelleri',
        company: 'Şirket',
        aboutUsLink: 'Hakkımızda',
        contactUs: 'Bize Ulaşın',
        pricingLink: 'Fiyatlar',
        faqs: 'SSS',
        refundPolicy: 'İade Politikası',
        privacyPolicy: 'Gizlilik Politikası',
        termsAndConditions: 'Şartlar ve Koşullar',
        imageToVideoAI: 'Görsel\'den Video\'ya AI',
        textToVideoAI: 'Metin\'den Video\'ya AI',
        aiVideoEditor: 'AI Video Düzenleyici',
        aiWatermarkRemoval: 'AI Filigran Kaldırma',
        aiVideoFaceSwap: 'AI Video Yüz Değiştirme',
        aiVideoLipSync: 'AI Video Dudak Senkronizasyonu',
        aiVideoSubtitleErase: 'AI Altyazı Silme',
        aiVideoStylization: 'AI Video Stilizasyonu',
        aiVideoEnhancement: 'AI Video İyileştirme',
        aiImageGenerator: 'AI Görsel Oluşturucu',
        imageToImageAI: 'Görsel\'den Görsel\'e AI',
        aiImageAspectRatioConverter: 'AI Görsel Boyut Ayarlayıcı',
        aiImageUpscaler: 'AI Görsel İyileştirici',
        aiImageUpscalerDesc: 'Tek tıkla büyütün, gürültüyü azaltın ve bulanık fotoğrafları geri yükleyin',
        aiImageTranslation: 'AI Görsel Çevirisi',
        aiImageRatioConversion: 'AI Görsel Oran Dönüşümü',
        aiImageQualityUpgrade: 'AI Görsel Kalite Yükseltme',
        aiBackgroundChanger: 'AI Arka Plan Değiştirici',
        aiBackgroundChangerDesc: 'Fotoğraf arka planlarını istediğiniz herhangi bir sahneyle değiştirin',
        aiDancingVideoGenerator: 'AI Dans Videosu Oluşturucu',
        aiKissingVideoGenerator: 'AI Öpüşme Videosu Oluşturucu',
        veo31Link: 'Veo 3.1',
        veo31Desc: 'Geliştirilmiş gerçekçilik ve ses senkronizasyonu',
        veo3: 'Veo 3',
        veo3Desc: 'Yüksek kaliteli video oluşturma modeli',
        veo3Fast: 'Veo 3 Fast',
        veo3FastDesc: 'Hızlı video oluşturma modeli',
        sora2: 'Sora 2',
        sora2Desc: 'Gerçekçi dünya ve ses simülasyonu',
        weryaiVideo1: 'WeryAI Video 1.0',
        weryaiVideo1Desc: 'Hızlı, sinematik ve tutarlı video anlatımı için 微鲤AI\'nin amiral gemisi modeli',
        KlingAI: 'Kling 2.5',
        KlingAIDesc: 'AI video oluşturma platformu',
        Kling26Pro: 'Kling 2.6 Pro',
        Kling26ProDesc: 'Görsel-işitsel senkronize video oluşturma',
        KlingO1: 'Kling O1',
        KlingO1Desc: 'Birleşik çok modlu video modeli',
        runway: 'Runway',
        runwayDesc: 'Profesyonel AI video düzenleme platformu',
        runway45: 'Runway Gen-4.5',
        runway45Desc: 'Benzeri görülmemiş fizik simülasyonu, A2D hibrit mimari, sinematik zamansal tutarlılık',
        hailuoAI: 'Hailuo AI',
        hailuoAIDesc: 'Gelişmiş AI video oluşturma',
        hailuo23: 'Hailuo 2.3',
        hailuo23Desc: 'Yeni nesil AI video oluşturma',
        seedance: 'Seedance',
        seedanceDesc: 'Yaratıcı video oluşturma AI',
        seedanceProFast: 'Seedance 1.0 Pro Fast',
        seedanceProFastDesc: 'Yüksek hızlı düşük maliyetli video oluşturma',
        dreamina3: 'Dreamina 3.0',
        dreamina3Desc: 'Hassas kamera kontrolü ile sinematik video oluşturma',
        wanAI: 'Wan AI',
        wanAIDesc: 'Wan AI video oluşturma modeli',
        pika22: 'Pika 2.2',
        pika22Desc: 'Keskin, net, yüksek kaliteli görseller',
        nanoBanana2Link: 'Nano Banana Pro',
        nanoBanana2Desc: 'Dünyanın ilk "çıkarım görsel motoru"',
        nanoBananaLink: 'Nano Banana',
        nanoBananaDesc: 'Kompakt ve verimli görsel oluşturma',
        flux: 'FLUX',
        fluxDesc: 'Yüksek kaliteli görsel oluşturma modeli',
        fluxKontext: 'Flux Kontext',
        fluxKontextDesc: 'Bağlam farkında görsel oluşturma',
        imagen: 'Imagen',
        imagenDesc: 'Google\'ın gelişmiş görsel oluşturması',
        gpt4o: 'GPT-4o',
        gpt4oDesc: 'Görsel yetenekleri olan çok modlu AI',
        qwenImage: 'Qwen Image',
        qwenImageDesc: 'Qwen destekli görsel oluşturma',
        seedream: 'Seedream 4.0',
        seedreamDesc: 'Yaratıcı görsel oluşturma platformu',
        dreamina: 'Dreamina',
        dreaminaDesc: 'Sinematik AI görsel oluşturma',
        supportedVideoModels: 'Desteklenen Video Modelleri',
        supportedImageModels: 'Desteklenen Görsel Modelleri',
        wanAIImageDesc: 'Wan AI görsel oluşturma modeli',
        seedream45: 'Seedream 4.5',
        seedream45Desc: 'ByteDance\'ın amiral gemisi AI görsel modeli, hassas tipografi ve çoklu görsel füzyonu ile',
    },
        nanoBananaProLink: 'Nano Banana Pro',
    }
